import { useMemo } from "react";

import {
  NAV_GROUP_NAMES,
  NAV_V3_ITEMS,
} from "@/components/navigation/primary/constants";
import { filterNavItemsByRoles } from "@/components/navigation/primary/filter-nav-by-roles";
import { PrimaryNavigationItemCollapsableWithIconI } from "@/components/navigation/primary/interfaces";
import { useManageMe } from "@/hooks/use-manage-me";

/**
 * The "Team" group with the pages the user's roles allow (C-14), otherwise
 * nothing. Fails closed: loading, the switch off (404 + 1035), any error and
 * a user with no role all hide it, so the nav renders exactly as before.
 */
export const useTeamNavItems =
  (): Array<PrimaryNavigationItemCollapsableWithIconI> => {
    const { status, me, hasRoles } = useManageMe();

    return useMemo(() => {
      if (status !== "on" || !hasRoles) {
        return [];
      }

      return filterNavItemsByRoles([NAV_V3_ITEMS[NAV_GROUP_NAMES.TEAM]], me);
    }, [status, me, hasRoles]);
  };
